import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
import { useStore } from "vuex";
import { computed, nextTick, onMounted, ref } from "vue";
import { useChildren } from '@vant/use';
import { isMobile } from "@/utils/devices";
const __default__ = {
  name: 'App'
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const store = useStore();
    const theme = computed(() => {
      return store.theme;
    });

    //向子组件提供刷新操作
    const isRouterAlive = ref(true);
    const {
      linkChildren
    } = useChildren();
    const reload = () => {
      isRouterAlive.value = false;
      nextTick(() => {
        isRouterAlive.value = true;
      });
    };
    linkChildren({
      reload
    });
    onMounted(() => {
      if (!isMobile() && process.env.VUE_APP_PC_ADAPTER == 'true') {
        location.href = process.env.VUE_APP_CPS_PC_URL;
      }
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createBlock(_component_van_config_provider, {
        theme: theme.value
      }, {
        default: _withCtx(() => [isRouterAlive.value ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["theme"]);
    };
  }
});